/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsProfileTournamentTeamDtoSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  tag: z.string().nullish(),
  icon: z.string().nullish(),
  captainId: z.string().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  tournamentId: z.string().nullish(),
  tournamentName: z.string().nullish(),
  tournamentStatus: z.string().nullish(),
});
